import { useState } from "react";
import PropTypes from "prop-types";
import { Steps } from "primereact/steps";
import { Form } from "react-final-form";
import { Button } from "primereact/button";
import { useIntl } from "react-intl";
import FormContext from "./FormContext";
import "./wizardForm.scss";

const WizardForm = ({
  steps,
  onWizardSubmit,
  onCancel,
  values,
  formOtherProps = {},
}) => {
  const intl = useIntl();
  const [activeIndex, setActiveIndex] = useState(0);

  const { action, requesting } = formOtherProps;

  const onSubmit = (values) => {
    if (activeIndex < steps.length - 1) {
      setActiveIndex(activeIndex + 1);
    } else if (onWizardSubmit) {
      onWizardSubmit(values);
    }
  };

  const onPrevious = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    } else {
      onCancel();
    }
  };

  const ActiveComponent = steps[activeIndex].Component;

  return (
    <div className="edexlms-wizard-form-container">
      <Steps
        model={steps.map((step) => ({ label: step.label }))}
        activeIndex={activeIndex}
      />
      <div className="edexlms-wizard-form-content">
        <Form
          initialValues={values}
          subscription={{ submitting: true, pristine: true }}
          onSubmit={onSubmit}
          mutators={{
            setValue: ([field, value], state, { changeValue }) => {
              changeValue(state, field, () => value);
            },
          }}
        >
          {({ handleSubmit, ...formProps }) => {
            const setValue = formProps?.form?.mutators?.setValue || null;
            return (
              <FormContext.Provider
                value={{
                  setValue,
                }}
              >
                <form
                  onSubmit={handleSubmit}
                  className="flex basis-full grow shrink flex-column h-full p-3"
                  noValidate
                >
                  <div className="edexlms-wizard-form flex-grow-1">
                    <div className="edexlms-wizaed-form-component">
                      <ActiveComponent {...formOtherProps} />
                    </div>
                  </div>
                  <div className="edexlms-wizard-form-footer align-self-end flex-shrink-0 gap-2 flex">
                    <Button
                      className="w-8rem"
                      type="button"
                      outlined
                      onClick={onPrevious}
                      disabled={requesting && action === "create"}
                    >
                      <div className="gap-2 flex justify-content-center w-full">
                        {activeIndex === 0
                          ? intl.formatMessage({ id: "cancel" })
                          : intl.formatMessage({ id: "previous" })}
                      </div>
                    </Button>
                    <Button
                      className="w-8rem"
                      disabled={requesting && action === "create"}
                    >
                      <div className="gap-2 flex justify-content-center w-full">
                        {activeIndex < steps.length - 1
                          ? intl.formatMessage({ id: "next" })
                          : intl.formatMessage({ id: "submit" })}
                      </div>
                    </Button>
                  </div>
                </form>
              </FormContext.Provider>
            );
          }}
        </Form>
      </div>
    </div>
  );
};

WizardForm.propTypes = {
  steps: PropTypes.array.isRequired,
  onWizardSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  values: PropTypes.object,
};

export default WizardForm;
